import { ReactElement } from 'react';
import ResetPasswordForm from './components/ResetPasswordForm';
import { HeadTag } from 'shared/components';

const ResetPasswordPage = (): ReactElement => (
    <>
        <HeadTag title="ResetPassword" />
        <ResetPasswordForm />
    </>
);

export default ResetPasswordPage;
